if (!customElements.get('infinite-scroll')) {
  class InfiniteScroll extends HTMLElement {
    constructor() {
      super();
      this.loading = false;
      this.observer = null;
    }

    connectedCallback() {
      if (this.dataset.disabled === 'true') return;
      if (!this.dataset.nextUrl) return;

      this.grid = document.getElementById('product-grid');
      if (!this.grid) return;

      this.sectionId = this.dataset.sectionId;
      this.spinner = this.querySelector('.infinite-scroll__spinner');

      const pagination = this.querySelector('.pagination-wrapper');
      if (pagination) {
        pagination.classList.add('hidden');
        pagination.setAttribute('aria-hidden', 'true');
      }

      this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
        rootMargin: '0px 0px 800px 0px',
      });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }

    onIntersect(entries) {
      if (this.loading) return;
      const isVisible = entries.some((entry) => entry.isIntersecting);
      if (!isVisible) return;
      this.loadNextPage();
    }

    loadNextPage() {
      const nextUrl = this.dataset.nextUrl;
      if (!nextUrl) return;

      this.loading = true;
      if (this.spinner) this.spinner.classList.remove('hidden');

      const separator = nextUrl.indexOf('?') === -1 ? '?' : '&';
      const url = `${nextUrl}${separator}section_id=${this.sectionId}`;

      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const newGrid = html.getElementById('product-grid');
          const newInfiniteScroll = html.querySelector('infinite-scroll');

          if (newGrid && this.grid) {
            Array.from(newGrid.children).forEach((item) => {
              this.grid.appendChild(item);
            });
          }

          const newNextUrl = newInfiniteScroll ? newInfiniteScroll.dataset.nextUrl : '';
          this.dataset.nextUrl = newNextUrl || '';

          if (!this.dataset.nextUrl && this.observer) {
            this.observer.disconnect();
          }

          if (typeof initializeScrollAnimationTrigger === 'function') {
            initializeScrollAnimationTrigger(this.grid);
          }

          document.dispatchEvent(
            new CustomEvent('infinite-scroll:page-loaded', {
              detail: { grid: this.grid, sectionId: this.sectionId },
            })
          );
        })
        .catch((error) => {
          console.error('Infinite scroll: failed to load next page', error);
        })
        .finally(() => {
          this.loading = false;
          if (this.spinner) this.spinner.classList.add('hidden');
        });
    }
  }

  customElements.define('infinite-scroll', InfiniteScroll);
}
